import React from 'react';
import { MutationStatus } from 'react-query';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { usePostAdminApplicationFilePresigned } from '../../../api-refactored/manage-announcements/usePostAdminApplicationFilePresigned';

interface IPostPresignLinks {
  files: UploadedFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  setShouldSubmit: React.Dispatch<React.SetStateAction<boolean>>;
  setApiButtonStatus: React.Dispatch<React.SetStateAction<MutationStatus>>;
}
const usePostPresignLinksforOpsAdmin = ({
  files,
  setFiles,
  setShouldSubmit,
  setApiButtonStatus,
}: IPostPresignLinks) =>
  usePostAdminApplicationFilePresigned({
    onSuccess: (data) => {
      const newFiles: UploadedFile[] = [];
      data.forEach((_value, index) => {
        const pendingFile = files[index];
        const fileData = data[index];
        pendingFile.presignedUrl = fileData.presignedUrl;
        pendingFile.key = fileData.key;
        newFiles.push(pendingFile);
      });
      setFiles(newFiles);

      setShouldSubmit(true);
    },
    onError: () => setApiButtonStatus('error'),
  });

export default usePostPresignLinksforOpsAdmin;
